

<div class="d-flex align-items-center justify-content-between loginheader">

  <div class="py-3 d-flex align-items-center">
    <!--<img alt="MSSIDC Logo" class="MSSIDC-logo" src="assets/Images/MSSIDC_logo.png">-->
    <a href="https://testmssidcweb.mahaitgov.in/"><img alt="MSSIDC Logo" class="MSSIDC-logo" src="assets/Images/MSSIDC_logo.png"></a>

    <div class="logoText ps-3">
      <p class="header-h1">Maharashtra Small Scale Industries Development Corporation Ltd.</p>

      <p class="header-h2">A Government Of Maharashtra Undertaking <small>CIN No. U74999MH1962SGC012501</small></p>
    </div>
  </div>

  <div class="d-flex"><a href="https://www.maharashtra.gov.in/" target="_blank" data-bs-toggle="modal" data-bs-target="#gotowebsite"><img alt="" class="maha-logo" src="assets/Images/Maharashtra-Gov-Logo.png"></a> <a href="https://www.india.gov.in/" target="_blank" data-bs-toggle="modal" data-bs-target="#gotowebsite"><img alt="" class="emblem-logo" src="assets/Images/national_emblem_white.svg"></a></div>


</div>
<section>
  <div class="container">
    <mat-card-content>
      <mat-card class="example-card" appearance="outlined">
        <mat-card-header>
          <mat-card-title>Registration</mat-card-title>
        </mat-card-header>
        <mat-card-subtitle class="text-center">Register As</mat-card-subtitle>
        <div class="row">
          <div class="col-md-6 d-flex flex-column align-items-center">
            <mat-card-actions class="registeras">
              <button mat-button id="btnRegisterAsMSME" (click)="gotoMSMERegistration()"><img src="assets/Images/company.png" alt="MSME" />MSME</button>
            </mat-card-actions>
            <p>(Micro, Small and Medium Enterprises)</p>
          </div>
          <div class="col-md-6 d-flex flex-column align-items-center">
            <mat-card-actions class="registeras">
              <button mat-button id="btnRegisterAsIA" (click)="gotoIARegistration()"><img src="assets/Images/testing.png" alt="IA" /><br />IA</button>
            </mat-card-actions>
            <p>(Implementation Agency)</p>
          </div>
        </div>
        <button class="btn btn-danger mb-3" id="btncancel" type="submit" [routerLink]="'/login'">Cancel</button>
      
        <div class="alert alert-warning font-mobile">(Click on the User Type mentioned above to proceed with Registration)</div>
      </mat-card>
      
    </mat-card-content>

    

  </div>
</section>
<footer>
  <div class="container">
    <div class="row">

      <div class="col-sm-9">
        <div class="copyright">Copyright © 2024. All rights reserved to<span> Maharashtra Small Scale Industries Development Corporation Ltd</span></div>
      </div>
      <div class="col-sm-3">
        <div class="maintain">Designed by <a href="https://mahait.org/" target="_blank" data-bs-toggle="modal" data-bs-target="#gotowebsite">MAHAIT</a></div>
      </div>

    </div>
  </div>
</footer>


<!--<div class="container d-flex justify-content-center align-items-center vh-100">
  <mat-card class="example-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title class="text-center">Registration</mat-card-title>
    </mat-card-header>
    <mat-card-subtitle class="text-center">Register As</mat-card-subtitle>
    <div class="row text-center">
      <div class="col-md-6 d-flex flex-column align-items-center">
        <mat-card-actions>
          <button mat-button id="btnlogin">MSME</button>
        </mat-card-actions>
        <p>(Micro, Small and Medium Enterprises)</p>
      </div>
      <div class="col-md-6 d-flex flex-column align-items-center">
        <mat-card-actions>
          <button mat-button id="btnlogin">IA</button>
        </mat-card-actions>
        <p>(Implementation Agency)</p>
      </div>
    </div>
    <p>(Click on the User Type mentioned above to proceed with Registration)</p>
  </mat-card>
</div>-->
